import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import State from "../../../../../context";
import { Flex, Image, Layout, theme, Switch } from "antd";
import MenuProfile from "../../../../../atom/MenuProfile";
import MenuSidebar from "../../../../../molecule/MenuSidebarLegacy";
import ModalAddProspect from "../../advisor/component/ModalAddProspect";
import ModalConversationDetails from "../../../../wealth/tenant/super_admin/component/ModalConversationDetails";
import ModalLevelClientDetails from "../../advisor/component/ModalLevelClientDetails";
import ModalManagerSettings from "../../admin/component/ModalManagerSettings";
import ModalProposalGuideManager from "../../advisor/component/ModalProposalGuideManager";
import ProposalHeader from "../page/PageGoals/component/ProposalHeader";
import SectionAskAdvice from "../../../../../organism/SectionAskAdvice";

import StyledContainer from "./style";

import { SIDEBAR_TABS } from "./constant";

import {
  isOrganizationBluepoint,
  isOrganizationOneascent,
  isOrganizationRivershares,
  isPortalProposal,
} from "../../../../../utils/helper/specialized";

import { ReactComponent as ShowLearning } from "./image/show_learning.svg";
import bluepoint_logo from "../../../../bluepoint/images/logo.png";

const LayoutProposal = ({ children }) => {
  const navigate = useNavigate();
  const { token } = theme.useToken();
  const [state, setState] = useContext(State);

  const organization = state.orgName ?? state.organization?.name;

  const getLogo = () => {
    if (isOrganizationBluepoint(organization)) {
      return <Image preview={false} src={bluepoint_logo} />;
    }
  };

  const getMenuItems = () => {
    // proposal app user navigation
    if (
      state.subscriptionType === "AdviserClient" ||
      state.subscriptionType === "AdviserLead" ||
      isPortalProposal()
    ) {
      if (isOrganizationOneascent(organization)) {
        return SIDEBAR_TABS.oneascent.proposal;
      } else if (isOrganizationRivershares(organization)) {
        return SIDEBAR_TABS.rivershares.proposal;
      }
    }
  };

  const onSidebarItemClick = () => {
    state.viewMilestonesQuestionnaire &&
      state.setKeyValue("viewMilestonesQuestionnaire", false);
    state.viewPerspectiveIndividualResults &&
      state.setKeyValue("viewPerspectiveIndividualResults", false);
    state.viewPerspectiveCoupleResults &&
      state.setKeyValue("viewPerspectiveCoupleResults", false);
    state.viewPrioritiesCoupleResults &&
      state.setKeyValue("viewPrioritiesCoupleResults", false);
  };

  return (
    <StyledContainer>
      <Layout style={{ height: "100vh" }}>
        <Layout.Sider
          breakpoint="md"
          collapsedWidth="0"
          style={{ background: token.sidebar_background }}
          width={token.sidebar__width}
        >
          <Flex
            align="center"
            justify="space-between"
            style={{
              height: "100%",
              padding: "26px 0 50px",
              width: "100%",
            }}
            vertical
          >
            <Flex gap={30} style={{ width: "100%" }} vertical>
              <Flex
                className="pointer"
                id="headerLogo"
                justify="center"
                onClick={() => navigate(getMenuItems()[0].path)}
              >
                {token.sidebar_logo ? (
                  <Image preview={false} src={token.sidebar_logo} />
                ) : (
                  getLogo()
                )}
              </Flex>
              <MenuSidebar
                email={state._id}
                itemsLayoutVertical={token.sidebar_icon_layout_vertical}
                onItemClick={onSidebarItemClick}
                routes={getMenuItems()?.filter(it => !it.hidden)}
              />
            </Flex>

            <Flex gap={24} vertical>
              <MenuProfile hideName logoutLink="/login" />
              {isOrganizationOneascent(organization) && (
                <Flex align="center" gap={6} justify="center" vertical>
                  <span
                    style={{
                      color: "#74C2E6",
                      fontSize: 12,
                      textAlign: "center",
                    }}
                  >
                    Show
                    <br />
                    Learning
                  </span>
                  <ShowLearning />
                  <Switch
                    onClick={() =>
                      state.setKeyValue("showLearning", !state.showLearning)
                    }
                    value={state.showLearning}
                  />
                </Flex>
              )}
            </Flex>
          </Flex>
        </Layout.Sider>
        <Layout>
          {isPortalProposal() && (
            <ProposalHeader
              openModal={state.openModal}
              organization={state.organization?.name ?? state.orgName}
            />
          )}

          <Layout.Content
            style={{
              background: "#ffffff",
              overflow: "auto",
              scrollBehavior: "smooth",
            }}
          >
            {children}
          </Layout.Content>
        </Layout>

        <ModalAddProspect
          handleClose={() => state.setKeyValue("addProspectModal", false)}
          open={state.addProspectModal}
        />
        <ModalLevelClientDetails
          handleClose={() =>
            state.setKeyValue("openModalLevelClientDetails", false)
          }
          open={state.openModalLevelClientDetails}
        />
        <ModalConversationDetails
          onCancel={() => state.setKeyValue("conversationModal", false)}
          open={state.conversationModal}
        />
        <ModalManagerSettings
          onCancel={() => state.setKeyValue("openModalManagerSettings", false)}
          open={state.openModalManagerSettings}
        />
        <ModalProposalGuideManager
          handleClose={() => state.setKeyValue("openModalProposalGuide", false)}
          open={state.openModalProposalGuide}
        />
        <SectionAskAdvice state={state} setState={setState} />
      </Layout>
    </StyledContainer>
  );
};

export default LayoutProposal;
